import React, { Component } from 'react';
import { terbilang } from '../../../../../_utils/terbilang';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { Loader, Menu, Segment, Button } from 'semantic-ui-react';
import printJS from 'print-js';
import {messageGlobal} from '../../../../../_utils/message';
import { toIDR } from '../../../../../_utils/tocurrency';

export default class DetailBp extends Component {
   constructor(props) {
      super(props);
      this.state = {
         data: null,
         requests:true,
         Loader:false
      }

      this.printDocument = this.printDocument.bind(this);
   }
   
   printDocument() {
      printJS({
         printable:'data_print', 
         type:'html', 
         showModal:true
      })
   }

   componentWillMount(){      
      fetch(`${BaseURLDev}/bp/${this.props.match.params.id}`, {headers})
      .then(response => {
         if(response.status===404){
            messageGlobal({
               message:"Data tidak ditemukan",
               option:{direct:true},
               value:"/b/bp"
            })

            this.setState({data:null,requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json();
      })
      .then(parsedJSON => this.setState({data:parsedJSON.data, requests:false}))
      .catch(err => console.log("Fetch data error ", err))
      
   }

   capitalizeFirstLetter(string) {
      if(string.slice(1)===" "){
         return string.charAt(0).toUpperCase() + string.slice(2);
      }
      return string.charAt(0).toUpperCase() + string.slice(1);
   }

   render() {

      const styletb = {
         borderCollapse:'collapse',
         borderSpacing:0,
         borderStyle:'solid',
         width:'100%',
      }
      
      const { requests, data } = this.state;
      var count = 0;
      var counter = 0;
      if(data!==null){
         data.rincian.map((rek,ii)=>(
            count = count + rek.nilai
         ))
      }

      return (
         <div>
            {requests ? <Loader active inline='centered' /> :
            data===null ? null :
            <div>
               <Menu>
                  <Menu.Item>
                     <Button
                        color='red'
                        content='Kembali'
                        icon='arrow left'
                        loading={this.state.loading}
                        onClick={()=>window.location.href='/b/bp'}
                     />
                  </Menu.Item>
                  <Menu.Item>
                     <Button
                        color='blue'
                        content='Print BP'
                        loading={this.state.loading}
                        icon='print'
                        onClick={()=>this.printDocument()}
                     />
                  </Menu.Item>
                  <Menu.Item>
                     <Button
                        content='Edit BP'
                        loading={this.state.loading}
                        icon='pencil'
                        label={{ basic: true, color: 'red', pointing: 'left', content: `${data.no_bukti}` }}
                        onClick={()=>window.location.href='/b/bp/edit/'+data.public_id}
                     />
                  </Menu.Item>
               </Menu>
               <Segment>
                  <div id="data_print">
                     <table align="center" width="100%" style={{fontSize:'14px'}}>
                        <tbody>
                           <tr align="center">
                              <th colSpan="2">
                                 <p style={{fontSize:'18px',marginBottom: '25px'}}>PEMERINTAH PROVINSI NUSA TENGGARA BARAT<br />
                                 SETORAN BUKTI PENERIMAAN (BP)</p>
                              </th>
                           </tr>
                           <tr>
                              <td width="30%">Nomor BP</td>
                              <td>&nbsp;:&nbsp;{data.no_bukti}</td>
                           </tr>
                           <tr>
                              <td width="30%">Penyetor</td>
                              <td>&nbsp;:&nbsp;{data.nama_penyetor}</td>
                           </tr>
                           <tr>
                              <td width="30%">Harap diterima uang</td>
                              <td>&nbsp;:&nbsp;
                                 {toIDR(count)}
                              </td>
                           </tr>
                           <tr>
                              <td width="30%">Terbilang</td>
                              <td>&nbsp;:&nbsp;{this.capitalizeFirstLetter(terbilang(count))}</td>
                           </tr>
                           <tr>
                              <td colSpan="2"><i>Dengan rincian penerimaan sebagai berikut</i> :</td>
                           </tr>
                        </tbody>
                     </table>
                     <table border="1" align="center" style={styletb}>
                        <tbody>            
                           <tr align="left" style={{background:'#e5e5e5',padding:'4px'}}>
                              <th width="5%" style={{padding:'4px'}}>No.</th>
                              <th width="15%" style={{padding:'4px'}}>Rekening</th>
                              <th width="60%" style={{padding:'4px'}}>Uraian</th>
                              <th width="25%" style={{padding:'4px'}} align="right">Jumlah (Rp.)</th>
                           </tr>
                           {
                              data.rincian.map((rek,i)=>{
                                 counter = counter + 1
                                 return (<tr key={counter}>
                                    <td style={{padding:'4px'}} width="5%">{counter}.</td>
                                    <td style={{padding:'4px'}} width="15%">{`${rek.kd_rek_1}.${rek.kd_rek_2}.${rek.kd_rek_3}.${rek.kd_rek_4}.${rek.kd_rek_5}.${rek.kd_rek_6}`}</td>
                                    <td style={{padding:'4px'}} width="60%">{rek.uraian_rinc}</td>
                                    <td style={{padding:'4px'}} width="25%" align="right">{toIDR(rek.nilai)}</td>
                                 </tr>)
                              })
                           }
                           <tr style={{background:'#e5e5e5'}}>
                              <td style={{padding:'4px'}} colSpan="4" align="right">
                                 {toIDR(count)}
                              </td>
                           </tr>
                           <tr>
                              <td style={{padding:'4px'}} colSpan="4" align="right">
                                 <i>{this.capitalizeFirstLetter(terbilang(count))}</i>
                              </td>
                           </tr>
                        </tbody>            
                     </table>
                     <table align="center" width="80%" style={{marginTop:'25px'}}>
                        <tbody>
                           <tr align="left">
                              <td colSpan="2">Diterima pada : </td>
                           </tr>
                        </tbody>
                     </table>

                     <table align="center" width="80%" style={{marginTop:'30px'}}>
                        <tbody>
                           <tr align="center">
                              <td colSpan="2">
                                 Pegawai/Pejabat yang menyetujui<br />
                                 {data.jabatan_penandatangan}
                              </td>
                           </tr>
                           <tr align="center">
                              <td colSpan="2" style={{paddingTop:'40px'}}>
                                 <u>{data.nama_penandatangan}</u><br />
                                 {data.nip_penandatangan}<br />
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </Segment>
         </div> }
      </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_bp/DetailBp.js